import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import * as React from "react";

interface Props {
  icon?: IconDefinition;
  text: string;
  to: string;
  target?: React.HTMLAttributeAnchorTarget;
}

export function MainMenuNavItem({ icon, text, to, target }: Props) {
  const location = useLocation();
  const activeClass =
    location.pathname === to ? "active" : "link-body-emphasis";

  return (
    <li className="nav-item">
      <Link to={to} target={target} className={`nav-link  ${activeClass}`}>
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            width="16"
            height="16"
            className="me-1"
          />
        )}{" "}
        {text}
      </Link>
    </li>
  );
}
